export const LOCATION_OVERRIDE_COOKIE = "location-override";
export const USER_LOCATION_COOKIE = "prod-edx-cf-loc";
export const WPE_USER_LOCATION_HEADER = "wpe-headless-country";
export const CLOUDFRONT_USER_LOCATION_HEADER = "CloudFront-Viewer-Country";
export const USER_LOCATION_LATITUDE = "stage-edx-cf-iplatitude";
export const USER_LOCATION_LONGITUDE = "stage-edx-cf-iplongitude";
export const LOCATION_USA = "US";
export const METERS_IN_ONE_MILE = 1609;
export const PRECISION_RADIUS_MILES = 50;
